module.exports = __webpack_public_path__ + "assets/img/4-0.7801ff90.svg";